<template>
	<div class="flex justify-between gap-2 checkoutLineItemComponent">
		<div class="grow flex gap-2 md:gap-3">
			<!-- Nuxt Img component not working once deployed - IPX issue -->
			<img
				v-if="showProductImages"
				class="rounded-xl h-16 w-16 max-sm:mt-1 md:h-20 md:w-20 object-cover object-center"
				:src="imageSrc ?? runtimeConfig.public.DEFAULT_PRODUCT_IMAGE"
				alt="product image" />
			<div class="text-left my-auto">
				<p class="font-sans text-primary text-base pl-[2px]">{{ title }}</p>
				<div class="flex">
					<p class="basis-16 font-sans text-primary text-base pl-[2px]">
						{{ currency.symbol }}{{ numberHelper.formatPrice(price) }}
					</p>
					<p
						v-if="isReservationEnabled"
						class="inline underline mt-1 text-xs text-ternary hover:text-primary cursor-pointer"
						@click="editReservation">
						{{ $t("edit") }}
					</p>
				</div>
			</div>
		</div>

		<div
			v-if="isRemovable"
			class="flex flex-col text-center pt-1">
			<ButtonCounter
				text-style="font-serif text-ternary"
				:initial-value="quantity"
				:max="availableQuantity"
				@changed="counterChanged" />
			<p
				class="text-ternary hover:text-primary cursor-pointer hoverEffects underline text-sm mt-4"
				@click="removeItem">
				{{ $t("removeItem") }}
			</p>
		</div>
	</div>
</template>

<script setup>
	import { useNuxtApp } from "#app"
	import { useCurrencyStore } from "~/stores/CurrencyStore"
	import { storeToRefs } from "pinia"
	import numberHelper from "assets/helpers/numberHelper.js"

	const { id } = defineProps({
		id: String,
		title: String,
		summary: String,
		imageSrc: String,
		price: Number,
		quantity: Number,
		availableQuantity: Number,
		isRemovable: Boolean,
		isReservationEnabled: Boolean,
	})

	const runtimeConfig = useRuntimeConfig()
	const showProductImages = runtimeConfig.public.SHOW_PRODUCT_IMAGES
	const { $cartService, $seatSelector } = useNuxtApp()
	const currencyStore = useCurrencyStore()
	const { currency } = storeToRefs(currencyStore)

	const counterChanged = async ({ value }) => $cartService.$setCartItemQty(id, value)

	const removeItem = () => $cartService.$deleteCartItem(id)

	const editReservation = () => {
		$seatSelector.$editSelection()
	}
</script>

<style scoped></style>
